import useArrayFilters from 'hooks/useArrayFilters';
import { useMemo } from 'react';
import { useIntegrationDisplayNamesQuery } from 'IntegrationModule/api/queries/useIntegrationDisplayNamesQuery';

export const useIntegrationAgentsMultiSelector = ({
  integrationAgentsToExclude = [],
}: {
  integrationAgentsToExclude?: string[];
}) => {
  const { integrationDisplayNames, integrationDisplayNamesHash } =
    useIntegrationDisplayNamesQuery();

  const integrationKeys = useMemo(() => {
    const allKeys = integrationDisplayNames.map((i) => i.nonDisplayName);
    return integrationAgentsToExclude.length !== 0
      ? allKeys.filter((key) => !integrationAgentsToExclude.includes(key))
      : allKeys;
  }, [integrationDisplayNames, integrationAgentsToExclude]);

  const { items, selectedItems, onSelect } = useArrayFilters({
    items: integrationKeys,
  });

  return {
    selectedIntegrationAgents: selectedItems,
    onSelectIntegrationAgent: onSelect,
    integrationAgentItems: items,
    labelKey: 'displayName',
    integrationDisplayNamesHash,
  };
};
